import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import Item from 'components/Email/ItemModal';

function TableModal({vinculedClient, clientes = [], getClientes, totalPages, setPage, page, isSearched, setIsSearched }) {
    let myAbilities = HelpAbility();
    const { search, option, state } = isSearched;

    const handlePageClick = (data) => {
        state ? getClientes({ page: data.selected + 1, [option]: search }) : getClientes({ page: data.selected + 1 });
    };

    const resetClientes = async () => {
        setIsSearched({
            search: '',
            option: '',
            state: false
        })
        setPage(1);
        getClientes({});
    };
    return (
        <>
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Clientes registrados</h6>
                </div>
                <div className="col d-flex justify-content-end">
                    <div className="col-auto">
                        <button type="submit" className="btn btn-primary" onClick={resetClientes}>Cargar todos</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">#</th>
                            <th scope="col" className="text-center">Nombre</th>
                            <th scope="col" className="text-center">Número de Documento</th>
                            {myAbilities.hasAny([C.A.EMAIL.LINK]) &&
                            <th scope="col" className="text-center">Acción</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            clientes.length ?
                                clientes.map((cliente, i) => <Item
                                    key={cliente._id}
                                    i={i}
                                    cliente={cliente}
                                    vinculedClient={vinculedClient}
                                />)
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div>
                <ReactPaginate
                    previousLabel={"Anterior"}
                    nextLabel={"Siguiente"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    //Cuantas paginas quieres mostrar despues de los 3 ...
                    marginPagesDisplayed={1}
                    //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                    pageRangeDisplayed={2}
                    forcePage={page - 1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>

        </>
      
    )
}

export default TableModal
